import { getApps, deleteApp } from 'firebase/app';
import errorAction from 'shared/utils/errorAction';
import createAsyncAction from 'shared/utils/createAsyncAction';

import createAction from './';


const RELEASE_FIREBASE = createAsyncAction(createAction('RELEASE_FIREBASE'));

export const releaseFirebase = () => (dispatch) => {
  dispatch({
    type: RELEASE_FIREBASE.pending,
    meta: { apps: getApps() },
  });

  return Promise
    .all(getApps().map(app => deleteApp(app)))
    .then(() => dispatch({ type: RELEASE_FIREBASE.success }))
    .catch((err) => dispatch(errorAction(RELEASE_FIREBASE.failure, err)));
};
